import { useEffect } from 'react';

import { useTheme } from '@mui/material';

import { useWindowResize } from '@cast/design-system';
import { useMainLayout } from '@cast/shared-layout-ui';

export const useBackground = () => {
  useWindowResize();
  const { breakpoints } = useTheme();
  const { setStyleOverrides, sidebarState, sidebarRef } = useMainLayout();

  useEffect(() => {
    const right = sidebarRef?.current?.getBoundingClientRect().right;
    if (right) {
      setStyleOverrides({
        background: `linear-gradient(147deg, rgba(212, 229, 255, 0.27) 0%, #F4F6F9 22.44%) ${right}px 0 no-repeat`,
      });

      return () => {
        setStyleOverrides({});
      };
    }
    return undefined;
  }, [sidebarState, setStyleOverrides, breakpoints, sidebarRef]);
};
